import { ViewportScroller } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HiddenJob } from '@apply4u/Models/hidden-jobs';
import { JobSource } from '@apply4u/features/jobs/enums/job-source.enum';
import { SuitabilityType } from '@apply4u/models/job-application/suitability-type';
import { RecommendationModel } from '@apply4u/models/recommendation-model';
import { Job } from '@apply4u/models/search/job';
import { UserJobWishListDetail } from '@apply4u/models/userjobwishlist';
import { ContextService } from '@apply4u/services/context-service';
import { JobapplicationService } from '@apply4u/services/jobapplication.service';
import { LocalstorageService } from '@apply4u/services/localstorage.service';
import { JobSearchService } from '@apply4u/services/search/job-search.service';
import { ShowHideLogsService } from '@apply4u/services/showHideLogs.service';
import { ToasterMessageService } from '@apply4u/services/toaster-message.service';
import { UserConnectionService } from '@apply4u/services/userConnection.service';
import { UserjobwishlistService } from '@apply4u/services/userjobwishlist.service';
import { A4UAdminUserId } from '@apply4u/shared/constant/Local-storage-keys/context-level-keys';
import { LoginTypeKeys } from '@apply4u/shared/constant/Local-storage-keys/login-type-keys';
import { CandidateSuitabilityType } from '@apply4u/shared/enums/candidate-suitability-type.enum';
import { RecommendationType } from '@apply4u/shared/enums/recommendation-type.enum';
import { GetElementById } from '@apply4u/shared/helpers/common/common-helpers';
import { ToLowerCase } from '@apply4u/shared/helpers/common/string-helpers';
import { IsAny, IsFalse, IsNotNull, IsNotNullOrEmpty, IsNotZero, IsNotZeroNumber, IsNullOrEmpty, IsTrue } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { DecodeBase64, EncodeToBase64 } from '@apply4u/shared/helpers/encoding-helper';
import { FormatSeoUrl } from '@apply4u/shared/helpers/seo-helper';
import { JobDetailUrlSmartPipe } from '@apply4u/shared/pipes/job-detail-url-smart.pipe';
import { timer } from 'rxjs/internal/observable/timer';

@Component({
  selector: 'smart-job-card',
  templateUrl: './smart-job-card.component.html',
  styleUrls: ['./smart-job-card.component.css'],
  // changeDetection:ChangeDetectionStrategy.OnPush
})
export class SmartJobCardComponent implements OnInit, OnChanges,OnDestroy {
  @Input() Jobs: Job[];
  @Input() WordsToHighlight: string;
  @Input() HideApplyNow: boolean = false
  @Input() HideShortlist :boolean = false;
  @Input() IsShortlistRequired: boolean = false;
  @Input() IsMyApplicationPage: boolean = false;
  @Input() IsShowIconRequired: boolean = false;
  @Input() IsHideIconRequired: boolean = false;
  @Input() IsSearchResultPage: boolean = false;
  @Input() CurrentPageNumber: number;
  @Input() IsExternalRecords: boolean = false;
  @Input() CurrentVisitedPage: string;
  @Input() IsHomePageFeaturedJobs: boolean = false;
  @Output() OnRemoveJobFromList: EventEmitter<number> = new EventEmitter<number>();
  @Output() OnChangeCandidateSuitablity: EventEmitter<SuitabilityType> =  new EventEmitter<SuitabilityType>();
  @Output() OnHideJob: EventEmitter<Job> = new EventEmitter<Job>();
  @Output() OnUnhideJob: EventEmitter<HiddenJob> = new EventEmitter<HiddenJob>();
  
  WishListJobId: number;
  ShareJobId: number;
  RecommendationModel: RecommendationModel = new RecommendationModel();
  PostUrl: string = "";
  ContextService: ContextService;
  JobSearchService: JobSearchService;
  SuitabilityTypEnum = CandidateSuitabilityType;
  CandidateSuitabilityType = new SuitabilityType();
  JobSource = JobSource;
  RecommendationType = RecommendationType;
  RecommendedId: number;
  IsPageEvenNumber:boolean = false;
  Apply4UCardsUTMSource: string = "";
  Apply4UCardAltText: string = "";
  Apply4UCardImageSource: string = "";
  ContactUsCardUTMSource: string = "";
  ShowBanner: boolean = true;
  SeeMore: Boolean = true;
  A4UAdmin : any ;

  constructor(private contextService: ContextService,
    private cdr: ChangeDetectorRef,
    private toasterService: ToasterMessageService,
    private jobSearchService: JobSearchService,
    public JobApplicationService: JobapplicationService,
    private userConnectionService: UserConnectionService,
    private router: Router,
    private showHideLogsService: ShowHideLogsService,
    private userJobWishListService: UserjobwishlistService,
    private route: ActivatedRoute,
    private localStorage: LocalstorageService,
    private scroller: ViewportScroller,) {
    this.ContextService = this.contextService;
    this.JobSearchService = this.jobSearchService;
  }  

  ngOnInit(): void {
    this.A4UAdminUserId();
     
  }

  SetFocusOnViewedJob() {
    if(this.contextService.IsBrowser){
      let element = this.localStorage.GetItem("JobCardYAxis");
      if(IsNotNull(element)){
        timer(2000).subscribe(() => {
          let elementId = document.getElementById(element);
          if(IsNotNull(elementId)){
            elementId.scrollIntoView({behavior:'smooth', block: 'center', inline:'end'});
          }
          this.localStorage.RemoveItem("JobCardYAxis");          
        });
      }
    }
  }
  ngAfterViewInit(): void {
    if (this.ContextService.IsBrowser) {
      this.SetFocusOnViewedJob();
    }
  }

  Toggle() {
    this.SeeMore = !this.SeeMore;
  }

  ngOnDestroy(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {    
    if (IsAny(changes['Jobs']?.currentValue)) {
      this.AutoQuickApply();
    }

    if(IsNotZeroNumber(changes['CurrentPageNumber']?.currentValue) || IsNotNullOrEmpty(changes['CurrentVisitedPage'])){
      this.IsPageEven();
    }
  }

  AutoQuickApply(): void {
    if (IsAny(this.Jobs) && IsNotZero(this.JobApplicationService.QuickApplyJobId) && this.contextService.IsUserLoggedIn) {
      let job = this.Jobs.find(d => d.Id == this.JobApplicationService.QuickApplyJobId);

      this.JobApplicationService.QuickApply(job);
    }
  }

  OnWishListChange(isWishListed: boolean): void {
    let jobIndex = this.Jobs.findIndex(d => d.Id == this.WishListJobId);
    this.Jobs[jobIndex].IsShortListed = isWishListed;
  }

  OnWishListDelete(deletedListJobId: number): void {
    let jobIndex = this.Jobs.findIndex(d => d.Id == deletedListJobId);
    this.Jobs[jobIndex].IsShortListed = false;
  }

  OnWishListIconClick(job: any): void {
    let tagetElement = document.getElementById(`btnWishList_${job.Id}`);
    let wishListIndex = this.Jobs.findIndex(d => d.Id == job.Id);
   let jobWishlistName= localStorage.getItem(LoginTypeKeys.JobWishlistName);
    if (this.contextService.IsUserLoggedIn) {
      if (localStorage.getItem(LoginTypeKeys.DefaultJobWishlistId) == "0" || IsNullOrEmpty(localStorage.getItem(LoginTypeKeys.DefaultJobWishlistId)) || jobWishlistName === "") {
        // tagetElement.setAttribute("data-target", "#JobWishListModal");
        this.WishListJobId = job.Id;
        var element = document.getElementById("JobWishListModalId");
        if (IsNotNull(element)) {
          element.click();
        }
      }else {
        if (IsNotZero(job.Id)) {
          let userJobWishListDetail = new UserJobWishListDetail();
          userJobWishListDetail.LoggedInUserId = this.contextService.LoggedInUserId;
          userJobWishListDetail.JobId = job.Id;
          userJobWishListDetail.WishListId = Number(localStorage.getItem(LoginTypeKeys.DefaultJobWishlistId));

          if (job.IsShortListed == true) {
            this.userJobWishListService.DeleteUserJobWishlistDetail(userJobWishListDetail.WishListId, this.contextService.LoggedInUserId, job.Id).subscribe(result => {
              this.Jobs[wishListIndex].IsShortListed = false;
              job.TotalJobs -= 1;
              this.toasterService.Success("Removed from shortlist.");
              this.cdr.detectChanges();
            });
            } else {
            this.userJobWishListService.AddUserJobWishlistDetail(userJobWishListDetail).subscribe(result => {
              this.Jobs[wishListIndex].IsShortListed = true;
              job.TotalJobs += 1;

              this.toasterService.Success("Saved to " + localStorage.getItem(LoginTypeKeys.JobWishlistName) + " shortlist.");
              this.cdr.detectChanges();
            });
          }
        }
      }
    } else {
      this.toasterService.LoginMessageError();
      tagetElement.setAttribute("data-target", "");
    }
    this.cdr.detectChanges();
  }

  OnRecommendationChange(isExist: boolean): void {
    let jobIndex = this.Jobs.findIndex(d => d.Id == this.RecommendedId);
    this.Jobs[jobIndex].IsRecommended = isExist;
  }

  OnRecommendationIconClick(jobId: number): void {
    let tagetElement = document.getElementById(`btnRecommendationList_${jobId}`);

    if (this.contextService.IsUserLoggedIn) {
      tagetElement.setAttribute("data-target", "#RecommendedListModal");
      this.RecommendedId = jobId;
    } else {
      this.toasterService.LoginMessageError();
      tagetElement.setAttribute("data-target", "");
    }
  }
  
  OnShareJobClick(job: Job): void {
    let tagetElement = document.getElementById(`btnShareJob_${job.Id}`);

    if (this.contextService.IsUserLoggedIn) {
      this.ShareJobId = job.Id;

      if (job.Id == 0) {
        this.PostUrl = job.ApplicationURL;
      } else {
        let pipe = new JobDetailUrlSmartPipe();
        this.PostUrl = pipe.transform(job.Title, job.Id);
      }

      this.SendRecommendation();
      tagetElement.setAttribute("data-target", "#ShareJobModal");
    } else {
      this.toasterService.LoginMessageError();
      tagetElement.setAttribute("data-target", "");
    }
  }
  SendRecommendation(): void {
    this.RecommendationModel = new RecommendationModel();
    this.RecommendationModel.RecommendedId = this.ShareJobId;
    this.RecommendationModel.RecommendedbyUserId = this.contextService.LoggedInUserId;
    this.RecommendationModel.Title = "Job";
  }

  CompanyDetailPageUrl(companyName: string, companyId: number): string {
    let companyUrl = "";
    if (IsNotNullOrEmpty(companyName) && IsNotZeroNumber(companyId)) {
      let companyTitle = companyName;
      companyTitle = FormatSeoUrl(companyTitle);
      companyTitle = ToLowerCase(companyTitle);
      companyUrl = `/companies/${companyTitle}-profile-${companyId}`;
    }

    return companyUrl;
  }

  OnRemoveJobFromShortlistClick(shortListedDetailId: number) {
    if (IsNotZeroNumber(shortListedDetailId)) {
      this.OnRemoveJobFromList.emit(shortListedDetailId);
    } else {
      this.toasterService.ServerError();
    }
  }

  OnChangeCandidateSuitabilityType(detailId: number, suitabilityTypeId: number): void {
    if (IsNotZeroNumber(detailId) && IsNotZeroNumber(suitabilityTypeId)) {
      this.CandidateSuitabilityType.ApplicationDetailId = detailId;
      this.CandidateSuitabilityType.SuitabilityTypeId = suitabilityTypeId;     
      this.OnChangeCandidateSuitablity.emit(this.CandidateSuitabilityType);
    } else {
      this.toasterService.ServerError();
    }
  }
  
  ConnectToUserClick(job: Job): void {
    this.userConnectionService.ConnectToJobPostedUser(job);
  }

  OnDeleteConnectionRequestClick(job: Job): void {
    this.userConnectionService.CancelConnectionRequestWithJobPostedUser(job);
  }

  OnClickCompanyLogo(postedByUserId:number, companyName:string):void {
    if(IsNotNullOrEmpty(companyName)){
      if(IsNotZeroNumber(postedByUserId)){
        this.router.navigateByUrl(`/company-jobs/${postedByUserId.toString()}`);
      } 
    }     
  }

  HideJobClick(job: Job){
    this.OnHideJob.emit(job);
  }

  OnDownloadApp(){
    if(this.contextService.LoggedInUserId){
      this.localStorage.SetItem(`appDownloaded_${this.contextService.LoggedInUserId}`, 'true');
    }
  }

  get ShowDownloadBanner(): boolean {
    if (this.contextService.LoggedInUserId) {
      return !this.localStorage.GetItem(`appDownloaded_${this.contextService.LoggedInUserId}`);
    }
    return true;
  }

  HideBanner(){
    this.ShowBanner = false;
  }

  UnhideJobClick(job: HiddenJob){
    this.OnUnhideJob.emit(job);
  }

  IsPageEven(): void {
    if (IsNotZeroNumber(this.CurrentPageNumber)) {
      this.IsPageEvenNumber = this.CurrentPageNumber % 2 == 0 ? true : false;

      if (this.contextService.IsBrowser) {
        if (IsTrue(this.IsPageEvenNumber)) {
          // Page Number Even
          if (IsNotNullOrEmpty(this.CurrentVisitedPage) && this.CurrentVisitedPage == "Job-Search") {
            this.Apply4UCardsUTMSource = "https://www.apply4u.co.uk/search-jobs?utm_source=jobsearch&utm_medium=jobsearchcard&utm_term=Register&utm_content=searching%20&utm_campaign=JobsearchresultcardRR";
            this.ContactUsCardUTMSource = "https://www.apply4u.co.uk/contact-us?utm_source=jobsearchpartners&utm_medium= jobsearchpartnerscard&utm_term=Contact-Us&utm_content=searching&utm_campaign=JSresultpartnerscardRR";
            this.Apply4UCardImageSource = "assets/images/Job-Search-Banner-Cards/card2.webp";
            this.Apply4UCardAltText = "Tired of searching";
          } else if (IsNotNullOrEmpty(this.CurrentVisitedPage) && this.CurrentVisitedPage == "Job-Near-Me") {
            this.Apply4UCardsUTMSource = "https://www.apply4u.co.uk/search-jobs?utm_source=jobsnearme&utm_medium=jobsnearmecard&utm_term=Register&utm_content=searching%20&utm_campaign=JobsnearmecardRR";
            this.ContactUsCardUTMSource = "https://www.apply4u.co.uk/contact-us?utm_source=jobsnearmepartners&utm_medium= jobsnearmepartnerscard&utm_term=Contact-Us&utm_content=searching&utm_campaign=JNMresultpartnerscardRR";
            this.Apply4UCardImageSource = "assets/images/Job-Search-Banner-Cards/card2.webp";
            this.Apply4UCardAltText = "Tired of searching";
          } else if (IsNotNullOrEmpty(this.CurrentVisitedPage) && this.CurrentVisitedPage == "Job-Work-From-Home") {
            this.Apply4UCardsUTMSource = "https://www.apply4u.co.uk/search-jobs?utm_source=jobworkfromhome&utm_medium=jobworkfromhomecard&utm_term=Register&utm_content=searching%20&utm_campaign=JobworkfromhomecardRR";
            this.ContactUsCardUTMSource = "https://www.apply4u.co.uk/contact-us?utm_source=workfromhomepartners&utm_medium=workfromhomepartnerscard&utm_term=Register&utm_content=searching%20&utm_campaign=WFHpartnerscardRR";
            this.Apply4UCardImageSource = "assets/images/Job-Search-Banner-Cards/card2.webp";
            this.Apply4UCardAltText = "Tired of searching";
          }
        } else if (IsFalse(this.IsPageEvenNumber)) {
          // Page Number Odd
          if (IsNotNullOrEmpty(this.CurrentVisitedPage) && this.CurrentVisitedPage == "Job-Search") {
            this.Apply4UCardsUTMSource = "https://www.apply4u.co.uk/search-jobs?utm_source=jobsearch&utm_medium=jobsearchcard&utm_term=Register&utm_content=searching%20&utm_campaign=JobsearchresultcardRR";
            this.ContactUsCardUTMSource = "https://www.apply4u.co.uk/contact-us?utm_source=jobsearchpartners&utm_medium= jobsearchpartnerscard&utm_term=Contact-Us&utm_content=searching&utm_campaign=JSresultpartnerscardRR";
            this.Apply4UCardImageSource = "assets/images/Job-Search-Banner-Cards/card1.webp";
            this.Apply4UCardAltText = "The only job site Apply4U";
          } else if (IsNotNullOrEmpty(this.CurrentVisitedPage) && this.CurrentVisitedPage == "Job-Near-Me") {
            this.Apply4UCardsUTMSource = "https://www.apply4u.co.uk/search-jobs?utm_source=jobsnearme&utm_medium=jobsnearmecard&utm_term=Register&utm_content=searching%20&utm_campaign=JobsnearmecardRR";
            this.ContactUsCardUTMSource = "https://www.apply4u.co.uk/contact-us?utm_source=jobsnearmepartners&utm_medium= jobsnearmepartnerscard&utm_term=Contact-Us&utm_content=searching&utm_campaign=JNMresultpartnerscardRR";
            this.Apply4UCardImageSource = "assets/images/Job-Search-Banner-Cards/card1.webp";
            this.Apply4UCardAltText = "The only job site Apply4U";
          } else if (IsNotNullOrEmpty(this.CurrentVisitedPage) && this.CurrentVisitedPage == "Job-Work-From-Home") {
            this.Apply4UCardsUTMSource = "https://www.apply4u.co.uk/search-jobs?utm_source=jobworkfromhome&utm_medium=jobworkfromhomecard&utm_term=Register&utm_content=searching%20&utm_campaign=JobworkfromhomecardRR";
            this.ContactUsCardUTMSource = "https://www.apply4u.co.uk/contact-us?utm_source=workfromhomepartners&utm_medium=workfromhomepartnerscard&utm_term=Register&utm_content=searching%20&utm_campaign=WFHpartnerscardRR";
            this.Apply4UCardImageSource = "assets/images/Job-Search-Banner-Cards/card1.webp";
            this.Apply4UCardAltText = "The only job site Apply4U";
          }

        }
      }
    }
  }

  OnClickFeaturedJobs():void {
    if(IsTrue(this.IsHomePageFeaturedJobs)){
      this.localStorage.SetItem(LoginTypeKeys.JobseekerHomeFocusType,'Featured Jobs');
      this.localStorage.SetItem(LoginTypeKeys.JobSearchOptionId, "HomePageFeaturedJobsId");
    }
  }

  A4UAdminUserId() {
    let Apply4UAdminId = this.localStorage.GetItem(A4UAdminUserId);
    if (IsNotNull(Apply4UAdminId)) {
      let A4UAdmin = EncodeToBase64(Apply4UAdminId);
      if (IsNotNullOrEmpty(A4UAdmin)) {
        this.A4UAdmin = A4UAdmin;
      }
    } 
  }
}
